import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    TextField,
} from '@mui/material';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import Button from "components/CustomButtons/Button.js";
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";


const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    container: {
        width: '50%',
        marginTop: theme.spacing(1),
        backgroundColor: 'transparent',
        alignContent: 'center',
        borderRadius: "20px",
    },
    container1: {
        backgroundColor: 'var(--bg-card)',
        backdropFilter: 'blur(12px)',
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        padding: '30px',
        width: '100%',
        top: "19px",
        boxShadow: `0 8px 24px rgba(0, 0, 0, 0.3)`,
        border: 'var(--card-border)',
    },
    title: {
        color: 'var(--text-main)',
        padding: '20px',
        fontSize: 20,
        fontWeight: '700',
        background: 'var(--bg-card)',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderBottom: '1px solid var(--border-color)'
    },
    items: {
        margin: 0,
        width: '100%'
    },
    input: {
        fontSize: 18,
        color: "var(--text-main)"
    },
    inputdimmed: {
        fontSize: 18,
        color: "var(--text-secondary)"
    },
    carphoto: {
        height: '18px',
        marginRight: '10px'
    },
    buttonStyle: {
        margin: 0,
        width: '100%',
        height: 50,
        borderRadius: "10px",
        background: 'linear-gradient(135deg, #E9AE31 0%, #C58F1F 100%)',
        marginTop: '15px',
        color: '#000',
        fontWeight: "bold",
        '&:hover': {
            background: 'linear-gradient(135deg, #F0C35B 0%, #D8A535 100%)',
        }
    },
    label: {
        transformOrigin: "top right",
        right: 0,
        left: "auto"
    },
    inputRtl: {
        "& label": {
            right: 20,
            left: "auto",
            color: "var(--text-secondary)"
        },
        "& legend": {
            textAlign: "right"
        },
        "& label.Mui-focused": {
            color: '#E9AE31',
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#E9AE31",
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: "#E9AE31",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "var(--border-color)",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#E9AE31",
            },
        },
    },
    textField: {
        "& label": {
            color: "var(--text-secondary)",
        },
        "& label.Mui-focused": {
            color: '#E9AE31',
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#E9AE31",
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: "#E9AE31",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "var(--border-color)",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#E9AE31",
            },
        },
    },
    selectField: {
        color: "var(--text-main)",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E9AE31",
        },
    },
}));

export default function AddMoney(props) {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const {
        addToWallet
    } = api;
    const settings = useSelector(state => state.settingsdata.settings);
    const dispatch = useDispatch();
    const classes = useStyles();
    const userdata = useSelector(state => state.usersdata);
    const [users, setUsers] = useState(null);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
    const [userCombo, setUserCombo] = useState(null);
    const [amount, setAmount] = useState(0);

    useEffect(() => {
        if (userdata.users) {
            let arr = [];
            for (let i = 0; i < userdata.users.length; i++) {
                let user = userdata.users[i];
                arr.push({
                    'firstName': user.firstName,
                    'lastName': user.lastName,
                    'mobile': user.mobile,
                    'email': user.email,
                    'uid': user.id,
                    'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
                    'pushToken': user.pushToken ? user.pushToken : ''
                });
            }
            setUsers(arr);
        }
    }, [userdata.users, settings.AllowCriticalEditsAdmin, t]);

    const handleAddBalance = () => {
        if (userCombo && userCombo.uid && amount > 0) {
            dispatch(addToWallet(userCombo.uid, amount));
            setCommonAlert({ open: true, msg: t('success') });
        } else {
            setCommonAlert({ open: true, msg: t('no_details_error') });
        }
    }

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: '' })
    };

    return (
        <div style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', padding: '40px 24px' }}>
            <style>
                {`
                    .MuiAutocomplete-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
                        border-color: var(--border-color);
                    }
                    .MuiAutocomplete-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
                        border-color: var(--text-secondary);
                    }
                    .MuiAutocomplete-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
                        border-color: #E9AE31 !important;
                    }
                    .MuiAutocomplete-root .MuiInputLabel-outlined {
                        color: var(--text-secondary);
                    }
                    .MuiAutocomplete-root .MuiInputLabel-outlined.Mui-focused {
                        color: #E9AE31 !important;
                    }
                    .MuiAutocomplete-root .MuiAutocomplete-input {
                        color: var(--text-main) !important;
                    }
                    .MuiAutocomplete-popupIndicator {
                        color: var(--text-secondary) !important;
                    }
                    .MuiAutocomplete-clearIndicator {
                        color: var(--text-secondary) !important;
                    }
                    .MuiAutocomplete-noOptions {
                        color: var(--text-secondary);
                        background-color: var(--bg-card);
                    }
                    .MuiAutocomplete-paper {
                        background-color: var(--bg-card);
                        color: var(--text-main);
                    }
                    .MuiAutocomplete-option {
                        color: var(--text-main);
                    }
                    .MuiAutocomplete-option:hover {
                        background-color: rgba(233, 174, 49, 0.08) !important;
                    }
                    .MuiAutocomplete-option[aria-selected="true"] {
                        background-color: rgba(233, 174, 49, 0.2) !important;
                    }
                `}
            </style>
            <div className={classes.container} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', margin: 'auto' }}>
                <Grid item xs={12} sm={12} md={8} lg={8}>
                    <Grid item >
                        <Grid item xs={12}>
                            <Typography className={classes.title} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
                                {t('add_to_wallet_title')}
                            </Typography>
                        </Grid>
                        <div className={classes.container1}>
                            <Grid container spacing={2} >
                                <Grid item xs={12}>
                                    {users ?
                                        <UsersCombo
                                            className={classes.items}
                                            placeholder={t('select_user')}
                                            users={users}
                                            value={userCombo}
                                            onChange={(event, newValue) => {
                                                setUserCombo(newValue);
                                            }}

                                        />
                                        : null}
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <TextField
                                        id="datetime-local"
                                        label={t('amount')}
                                        type="number"
                                        variant={"outlined"}
                                        fullWidth
                                        className={isRTL === 'rtl' ? classes.inputRtl : classes.textField}
                                        InputProps={{
                                            className: classes.input
                                        }}
                                        value={amount}
                                        onChange={event => {
                                            const { value } = event.target;
                                            setAmount(value === '' || value === null || value === undefined ? 0 : parseFloat(value));
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <Button
                                        size="lg"
                                        onClick={handleAddBalance}
                                        variant="contained"
                                        color="secondaryButton"
                                        className={classes.buttonStyle}
                                    >
                                        {t('add_to_wallet')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
        </div>
    );
}